import { render, staticRenderFns } from "./ResolutionStatus.vue?vue&type=template&id=193b4796"
import script from "./ResolutionStatus.vue?vue&type=script&lang=js"
export * from "./ResolutionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports